import Decimal from 'decimal.js-light';

import type { OrganizationSubscriptionSchedule } from '@bugbug/core/types/organizations';
import type { Product } from '@bugbug/core/types/subscriptions';
import type { Maybe } from '@bugbug/core/types/utils';

export const formatProductPriceData = <TInput extends Product<Maybe<string>>>(
  product: TInput,
): Omit<TInput, keyof Product<Maybe<string>>> & Product<Decimal> => ({
  ...product,
  price: new Decimal(product.price ?? '0'),
  pricePerMonth: new Decimal(product.pricePerMonth ?? '0'),
  priceWithTax: new Decimal(product.priceWithTax ?? '0'),
  tax: new Decimal(product.tax ?? '0'),
  taxPercent: new Decimal(product.taxPercent ?? '0'),
});

export const formatOrganizationSubscription = <
  TInput extends OrganizationSubscriptionSchedule<Maybe<string>>,
>(
  subscription: TInput,
): Omit<TInput, keyof Product<Maybe<string>>> & OrganizationSubscriptionSchedule<Decimal> => ({
  ...subscription,
  totalPriceWithAddonsAndTax: new Decimal(subscription.totalPriceWithAddonsAndTax ?? '0'),
  taxPercent: new Decimal(subscription.taxPercent ?? '0'),
});
